// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main__chatlist {
  width: 350px;
  height: 82vh;
  background-color: #fff;
  overflow-y: auto;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}
.main__chatlist .chatlist__heading {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
  font-weight: 600;
}
.main__chatlist .chatlist__items {
  margin: 20px 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/ListChat/chatList.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,uCAAA;EACA,mBAAA;AACF;AACE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AACJ;AACE;EACE,cAAA;AACJ","sourcesContent":[".main__chatlist {\n  width: 350px;\n  height: 82vh;\n  background-color: #fff;\n  overflow-y: auto;\n  padding: 20px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n  border-radius: 10px;\n\n  .chatlist__heading {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 25px;\n    font-weight: 600;\n  }\n  .chatlist__items {\n    margin: 20px 0;\n  }  \n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
